import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Patients from "./components/Patients/Patient_component";
import { routes } from "./routesConfig";
import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { startSessionTimeout, stopSessionTimeout } from "./sessionTimeout";
import "./app.css";
import "./fonts.css";

const APP_STORE_URL =
  "https://apps.apple.com/pk/app/shalamar-patient-portal/id6695735854";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.sihspatient";

const getMobileStoreUrl = () => {
  const ua = navigator.userAgent || navigator.vendor || "";
  const platform =
    navigator.userAgentData?.platform || navigator.platform || "";
  const isMobileHint = navigator.userAgentData?.mobile === true;

  const isIOS =
    (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
    /iOS|iPhone|iPad/i.test(platform);

  const isAndroid = /android/i.test(ua) || /android/i.test(platform);

  if (isIOS) return APP_STORE_URL;
  if (isAndroid) return PLAY_STORE_URL;

  // DevTools "Responsive" / generic mobile emulation often only sets the mobile hint
  if (isMobileHint) {
    return /mac|ios|iphone|ipad/i.test(platform)
      ? APP_STORE_URL
      : PLAY_STORE_URL;
  }

  return null;
};

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const hidePatientDropdown = location.pathname === "/bookappointment";

  useEffect(() => {
    const timeoutDuration = 10 * 60 * 1000; // 10 minutes

    const handleSessionTimeout = () => {
      if (
        !localStorage.getItem("authToken") ||
        !localStorage.getItem("phoneNumber") ||
        !localStorage.getItem("deviceID")
      ) {
        return;
      }

      // Remove stored session data
      localStorage.removeItem("authToken");
      localStorage.removeItem("phoneNumber");
      localStorage.removeItem("deviceID");
      localStorage.removeItem("patientList");
      localStorage.removeItem("operator");
      localStorage.removeItem("name");
      localStorage.removeItem("pushToken");
      localStorage.removeItem("selectedCard");

      // Stop any existing timeouts
      stopSessionTimeout();

      // Notify user & redirect
      alert("Your session has expired. Please sign in again.");
      navigate("/signin");
    };

    // Check if session exists before starting timeout
    if (
      localStorage.getItem("authToken") &&
      localStorage.getItem("phoneNumber") &&
      localStorage.getItem("deviceID")
    ) {
      const cleanup = startSessionTimeout(
        timeoutDuration,
        handleSessionTimeout
      );
      return () => {
        cleanup(); // Cleanup on unmount
        stopSessionTimeout(); // Ensure timer is stopped on unmount
      };
    }
  }, [navigate]);

  // Mobile browsers are always sent to the native app store (signed in or out)
  useEffect(() => {
    const storeUrl = getMobileStoreUrl();
    if (!storeUrl) return;

    window.location.replace(storeUrl);
  }, []);

  return (
    <div>
      <Navbar /> {/* Navbar component appears on all pages */}
      {!hidePatientDropdown && <Patients />}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;
